<template>
  <div class="info">
    <Hero
      :backImg="require('../assets/img/info/hero.jpg')"
      :backImgSp="require('../assets/img/info/hero_sp.jpg')"
      alt=""
      title="募集要項"
      titleSub="企画開発職系（総合職）"
      text=""
    />
    <div class="contents">
      <div class="requirements-wrapper">
        <div class="requirements">
          <dl class="column">
            <dt>募集職種</dt>
            <dd>
              <p>①研究・技術職種</p>
              <p class="supplement">
                研究開発、プロセス開発、プラントエンジニアリング、生産技術、設計、知的財産、デジタル化推進、新事業創出、安全性評価 など
              </p>
              <p>②企画・営業職種</p>
              <p class="supplement">
                営業、経営企画、経理・財務、法務、人事、総務、調達、生産企画、情報システム など
              </p>
            </dd>
            <dt>募集学部・学科</dt>
            <dd>
              全学部・全学科（国公立・私立大学および大学院）、高等専門学校専攻科
              <p class="supplement">
                ※高等専門学校専攻科の方で、実務推進職系（一般職）へエントリーご希望の方は、<br />トップページの「新卒採用 実務推進職系（一般職）」よりご応募ください。
              </p>
            </dd>
            <dt>募集予定人数</dt>
            <dd>
              研究・技術職種 ： 15名程度<br />
              企画・営業職種 ： 5名程度<br />
              <p class="supplement">
                2025年度実績  研究・技術職種：18名 / 企画・営業職種：7名 計25名
              </p>
            </dd>
            <dt>選考内容</dt>
            <dd class="center-horizontal">
              <p>書類選考、適性検査、面接 など</p>
            </dd>
            <dt>初任給</dt>
            <dd>
              博士了：309,500円<br />
              修士了：280,500円<br />
              学部卒：263,500円<br />
              高専卒：263,500円（専攻科）<br />
              <p class="supplement">※2025年度実績、基本給のみ</p>
            </dd>
            <dt>昇給・賞与</dt>
            <dd class="center-horizontal">
              <p>昇給年1回・賞与年2回</p>
            </dd>
            <dt>勤務地</dt>
            <dd>
              <p>全事業所</p>
              <p class="supplement">
                本社：東京都（中央区）<br />
                事業所：福島県（いわき市）、茨城県（小美玉市）、兵庫県（丹波市）<br />
                営業所：大阪府（大阪市）、宮城県（仙台市）、福岡県（福岡市）<br />
                研究所：福島県（いわき市）、茨城県（小美玉市）、東京都（江東区）
              </p>
            </dd>
            <dt>勤務時間</dt>
            <dd>
              本社、営業所、研究所（小美玉市、江東区）<br class="br-only-mb" />9:00～17:30<br />
              事業所（いわき市）、研究所（いわき市）<br class="br-only-mb" />8:30～17:00<br />
              事業所（小美玉市、丹波市）<br class="br-only-mb" />9:00～17:30
              <p class="supplement">※一部フレックスタイム制あり</p>
            </dd>
            <dt>休日・休暇・休業</dt>
            <dd>
              <p>・完全週休2日制、祝日、年末年始 など</p>
              <p>・年間休日数124日（2025年）</p>
              <p>
                ・年次有給休暇（初年度15日、以降1年ごとに1日ずつ加算し、最高は20日）
              </p>
              <p class="supplement">※半日単位または１時間単位での取得も可能</p>
              <p style="margin-top: 0">
                ・転勤休暇、慶弔休暇、生理休暇、育児休業、介護休業 など
              </p>
            </dd>
            <dt>育成・研修・キャリア</dt>
            <dd>
              新入社員教育、OJT、役割別研修、海外・国内留学制度、応募型研修、
              論文審査制度、語学教育、各種学会・講習会派遣 など<br/>
              キャリア面談、キャリア自己申告制度 など
            </dd>
            <dt>その他</dt>
            <dd>
              <p>・本社・営業所地区のみ在宅勤務制度あり（8回/月を上限）</p>
              <p>・定年年齢 65歳（段階的に引き上げ）</p>
            </dd>
            <dt>お問い合わせ</dt>
            <dd>
              〒103-8552 東京都中央区日本橋浜町3-3-2<br />人事総務部 採用担当<br />
<!--              <a href="tel:0332494666" class="tel">-->
<!--                <img-->
<!--                  src="../assets/img/common/contact/kureha_tel.png"-->
<!--                  style="max-height: 40px"-->
<!--                />-->
<!--              </a>-->
<!--              <br />-->
              <a v-on:click="mail_to_info('', '')" class="mail">
                <img
                  src="../assets/img/common/contact/kureha_mail.png"
                  style="max-height: 40px"
                />
              </a>
            </dd>
          </dl>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Hero from '@/components/Hero.vue';
export default {
  name: 'info',
  components: {
    Hero,
  },
  data() {
    return {
      openTab: 1,
    };
  },
  methods: {
    openTabContents(number) {
      this.openTab = number;
    },
    converter: function (M) {
      var str = '',
        str_as = '';
      for (var i = 0; i < M.length; i++) {
        str_as = M.charCodeAt(i);
        str += String.fromCharCode(str_as + 1);
      }
      return str;
    },
    mail_to_info(k_1, k_2) {
      eval(
        String.fromCharCode(
          108,
          111,
          99,
          97,
          116,
          105,
          111,
          110,
          46,
          104,
          114,
          101,
          102,
          32,
          61,
          32,
          39,
          109,
          97,
          105,
          108,
          116,
          111,
          58
        ) +
          escape(k_1) +
          this.converter(
            String.fromCharCode(
              113,
              100,
              98,
              113,
              116,
              104,
              115,
              63,
              106,
              116,
              113,
              100,
              103,
              96,
              45,
              98,
              110,
              45,
              105,
              111,
              62,
              114,
              116,
              97,
              105,
              100,
              98,
              115,
              60
            )
          ) +
          escape(k_2) +
          "'"
      );
    },
    mail_to_iwaki(k_1, k_2) {
      eval(
        String.fromCharCode(
          108,
          111,
          99,
          97,
          116,
          105,
          111,
          110,
          46,
          104,
          114,
          101,
          102,
          32,
          61,
          32,
          39,
          109,
          97,
          105,
          108,
          116,
          111,
          58
        ) +
          escape(k_1) +
          this.converter(
            String.fromCharCode(
              114,
              96,
              104,
              120,
              110,
              116,
              44,
              106,
              113,
              104,
              63,
              106,
              116,
              113,
              100,
              103,
              96,
              45,
              98,
              110,
              45,
              105,
              111,
              62,
              114,
              116,
              97,
              105,
              100,
              98,
              115,
              60
            )
          ) +
          escape(k_2) +
          "'"
      );
    },
  },
};
</script>

<style scoped lang="scss">
::v-deep .page-title br:first-child {
  display: block;
}
.contents {
  max-width: 1000px;
  width: 90%;
  margin: 0 auto;
  padding: 100px 0 150px;
  @media print, screen and (max-width: 767px) {
    padding: 100px 0;
  }
}
.tab-wrapper {
  display: flex;
  max-width: 840px;
  margin: 0 auto;
  justify-content: space-between;
  .tab {
    cursor: pointer;
    width: calc(50% - 10px);
    font-size: 26px;
    background-color: #9e9e9e;
    color: #fff;
    border-radius: 5px 5px 0px 0px;
    text-align: center;
    font-weight: bold;
    @media print, screen and (max-width: 767px) {
      font-size: 20px;
    }
    @media print, screen and (max-width: 414px) {
      font-size: 16px;
      width: calc(50% - 2px);
    }
    &.sougou.active {
      background-color: #00797f;
    }
    &.ippan.active {
      background-color: #3fae00;
    }
  }
}
.column {
  display: flex;
  flex-wrap: wrap;
  border-top: 2px solid #00797f;
  margin: 0;
  @media print, screen and (max-width: 767px) {
    flex-direction: column;
  }
  & > dt {
    padding: 30px 0 0 0;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: bold;
    font-size: 22px;
    @media print, screen and (min-width: 768px) {
      width: 220px;
      border-bottom: 2px solid #00797f;
      padding: 30px 0;
    }
  }
  & > dd {
    padding: 30px 0;
    margin: 0;
    border-bottom: 2px solid #00797f;
    font-size: 18px;
    font-weight: bold;
    margin: 0;
    @media print, screen and (min-width: 768px) {
      width: calc(100% - 220px);
      box-sizing: border-box;
      padding-left: 64px;
    }
    @media print, screen and (max-width: 767px) {
      font-size: 16px;
    }
    p {
      line-height: 1.5em;
      margin: 0;
      text-indent: -1em;
      margin-left: 1em;
      &.supplement {
        font-size: 15px;
        font-weight: normal;
        text-indent: 0;
        margin-left: 0;
        & + p {
          margin-top: 10px;
        }
      }
    }
    & > .job-cat {
      background-color: #3fae00;
      color: #fff;
      font-size: 18px;
      text-align: center;
      margin: 0;
      margin-top: 30px;
      position: relative;
      border-radius: 5px 5px 0 0;
      &:after {
        content: '';
        width: 0;
        height: 0;
        border: 7px solid transparent;
        border-top: 7px solid #3fae00;
        position: absolute;
        bottom: -14px;
        left: 0;
        right: 0;
        margin: auto;
      }
    }
    & > dl {
      display: flex;
      // align-items: center;
      flex-wrap: wrap;
      background-color: #3fab0029;
      margin: 0;
      padding: 0 10px;
      &.last {
        & > dt,
        & > dd {
          border-bottom: 0;
        }
      }
      & > dt {
        color: #3fae00;
        font-size: 18px;
        width: 200px;
        padding: 30px 0;
        line-height: 1.5em;
        border-bottom: 2px solid #3fae00;
        @media print, screen and (max-width: 767px) {
          width: 30%;
        }
      }
      & > dd {
        margin: 0;
        width: calc(100% - 200px);
        font-size: 15px;
        font-weight: bold;
        line-height: 1.5em;
        padding: 30px 0;
        border-bottom: 2px solid #3fae00;
        p {
          line-height: 1.5em;
          margin: 0;
          text-indent: -0.7em;
          margin-left: 0.7em;
        }
        @media print, screen and (max-width: 767px) {
          width: calc(100% - 30%);
        }
      }
    }
    .tel,
    .mail {
      img {
        margin-top: 5px;
        vertical-align: middle;
      }
    }
  }
}

.center-horizontal{
  display: flex;
  align-items: center;
}

.br-only-mb{
  display: none;
  @media print, screen and (max-width: 767px) {
    display: block;
  }
}

.br-only-pc {
  display: block;
  @media print, screen and (max-width: 767px) {
    display: none;
  }
}

</style>
